import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { Seller } from '../../../models';
import { BUYER_SUPPORT_LINK } from '~shared/constants/links.constants';
import { ALL_PRODUCTS_TAB_FRAGMENT, TAKE_BACK_INFORMATION_TAB_FRAGMENT } from '~app/modules/seller/constants';
import { Params } from '@angular/router';
import { APP_CATALOG_ROUTE, FeatureToggleEnum } from '~shared/constants';
import { toLower } from 'lodash';
import { urlBuilder } from '@metromarkets/sdk';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '~env/environment';

const sellerQueryParams = 'f.options.seller.0';

@Component({
  selector: 'app-storefront-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent implements OnChanges, OnInit {
  @Input() tabId: string;
  @Input() activeTabId: string;
  @Input() title: string;
  @Input() content: Seller | string;

  isSellerModel: boolean;
  supportLink = BUYER_SUPPORT_LINK;
  allProductsRouterLink = `/${APP_CATALOG_ROUTE}`;
  allProductsQueryParams: Params;
  isReactPLPsEnabled: boolean;
  reactSellerQueryParam: string;
  searchCatalogURL: string = this.allProductsRouterLink;

  readonly takeBackInformation = TAKE_BACK_INFORMATION_TAB_FRAGMENT;
  readonly allProducts = ALL_PRODUCTS_TAB_FRAGMENT;
  private destroySubject$ = new Subject<void>();

  constructor(private featureFlagService: ActiveFeaturesConfigcatService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.featureFlagService
      .isFeatureEnabledReadyForCurrentCountry$(FeatureToggleEnum.FF_PLP_REACT_MIGRATION)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((isEnabled: boolean): void => {
        this.isReactPLPsEnabled = isEnabled;
        this.reactSellerQueryParam = `f.options.seller.0=${this.content}`;
        this.searchCatalogURL = `${environment.appBaseUrl()}/${APP_CATALOG_ROUTE}?${this.reactSellerQueryParam}`;
        this.cdr.detectChanges()
      });

    if (this.tabId === this.allProducts && typeof this.content === 'string') {
      this.allProductsQueryParams = urlBuilder.encode({ [sellerQueryParams]: toLower(this.content) });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      this.isSellerModel = !(typeof this.content === 'string');
    }
  }

  ngOnDestroy() {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
